import GroupIdpList from './model';
import create from './create';

GroupIdpList.create = create;

export default GroupIdpList;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/GroupIdpList/index.js